<page-toolbar [pageActions]="pageActions" [subtitle]="subtitle" [title]="title"></page-toolbar>


<page-content *ngIf="!!codeSnippet">
  <mat-card appearance="outlined">
    <mat-card-title>Details</mat-card-title>
    <table>
      <tr>
        <td>Title:</td>
        <td>{{codeSnippet.title}}</td>
      </tr>
      <tr>
        <td>Name:</td>
        <td>{{codeSnippet.name}}</td>
      </tr>
      <tr>
        <td>Description:</td>
        <td>{{codeSnippet.description}}</td>
      </tr>
      <tr>
        <td>Id:</td>
        <td>{{codeSnippet._id}}</td>
      </tr>
      <tr>
        <td>Group Id:</td>
        <td>{{codeSnippet.groupId}}</td>
      </tr>
      <tr>
        <td>Created:</td>
        <td>{{codeSnippet.created | date:'dd MMMM yyyy'}}</td>
      </tr>
      <tr>
        <td>Updated:</td>
        <td>{{codeSnippet.updated | date:'dd MMMM yyyy'}}</td>
      </tr>
    </table>
  </mat-card>

  <div class="spacer"></div>

  <code-area [isString]="true" [parent]="this.codeSnippet" [readOnly]="true" [type]="this.codeSnippet.type" [value]="this.codeSnippet.code"
                 key="code"></code-area>

  <div class="spacer"></div>

  <mat-card appearance="outlined" *ngIf="codeSnippet.code != codeSnippet.compiledCode">
    <mat-card-title>Compiled Code:</mat-card-title>
    <p>{{codeSnippet.compiledCode}}</p>
  </mat-card>

</page-content>
